import { Node } from "tiptap";
import { TextSelection } from "prosemirror-state";

function asColumnContent(schema, content) {
  if (!content || !content.size) {
    return schema.nodes.paragraph.create();
  }

  let hasBlock = false;
  content.forEach((child) => {
    if (child.isBlock) hasBlock = true;
  });

  if (hasBlock) return content;
  return schema.nodes.paragraph.create(null, content);
}

function columnsClass(layout) {
  return layout === "icon" ? "rte-columns rte-columns--icon" : "rte-columns";
}

function resolveLayout(dom) {
  if (!dom || !dom.getAttribute) return "equal";
  const attr = dom.getAttribute("data-layout");
  if (attr === "icon" || attr === "equal") return attr;
  if (dom.classList && dom.classList.contains("rte-columns--icon")) return "icon";
  return "equal";
}

export default class ColumnsNode extends Node {
  get name() {
    return "columns";
  }

  get schema() {
    return {
      group: "block",
      content: "column{2}",
      isolating: true,
      defining: true,
      attrs: {
        layout: { default: "equal" },
      },
      parseDOM: [
        {
          tag: 'div[data-type="columns"]',
          getAttrs: (dom) => ({ layout: resolveLayout(dom) }),
        },
        {
          tag: "div.rte-columns",
          getAttrs: (dom) => ({ layout: resolveLayout(dom) }),
        },
      ],
      toDOM: (node) => [
        "div",
        {
          "data-type": "columns",
          "data-layout": node.attrs.layout || "equal",
          class: columnsClass(node.attrs.layout),
        },
        0,
      ],
    };
  }

  commands({ type, schema }) {
    const insertColumns = (layout = "equal") => (state, dispatch) => {
      const columnType = schema.nodes.column;
      if (!columnType || !schema.nodes.paragraph) return false;

      const { empty, from, to, $from } = state.selection;
      let selectedContent = null;
      let replaceFrom = from;
      let replaceTo = to;

      if (!empty) {
        selectedContent = state.doc.slice(from, to).content;
      } else if ($from.parent && $from.parent.type.name === "paragraph") {
        replaceFrom = $from.before($from.depth);
        replaceTo = $from.after($from.depth);
        if ($from.parent.content.size) {
          selectedContent = $from.parent.content;
        }
      }

      let left;
      let right;
      if (layout === "icon") {
        // Narrow left column for the icon; existing text goes to the right.
        left = columnType.create(null, schema.nodes.paragraph.create());
        right = columnType.create(null, asColumnContent(schema, selectedContent));
      } else {
        left = columnType.create(null, asColumnContent(schema, selectedContent));
        right = columnType.create(null, schema.nodes.paragraph.create());
      }

      const columns = type.create({ layout }, [left, right]);
      if (!dispatch) return true;

      const tr = state.tr.replaceWith(replaceFrom, replaceTo, columns);
      // Cursor in left column (icon slot for icon layout, content for equal layout).
      const cursorPos = replaceFrom + 1 + 1 + 1;
      try {
        tr.setSelection(TextSelection.near(tr.doc.resolve(cursorPos)));
      } catch (e) {
        // keep default selection
      }

      dispatch(tr.scrollIntoView());
      return true;
    };

    return {
      columns: () => insertColumns("equal"),
      columnsIcon: () => insertColumns("icon"),
    };
  }
}
